import React, { useState, useCallback, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import { DynamicForm, SubmitBtn } from '../../../components';
import { useApi, useAuth, useRoutes } from '../../../hooks';
import { useAlert } from '../../../components/alert-info/use-alert';

export const EmargementForms: React.FC = () => {
  const { auth, isAgent } = useAuth();
  const params: any = useParams();
  const { queryParams, paths, navigate } = useRoutes();
  const { addEmargement, getEmargement, validateEmargement } = useApi();
  const [emargement, setEmargement] = useState();
  const [error, setError] = useState();
  const { show, AlertTypes } = useAlert();
  const handleOnSubmit = useCallback(
    async ({ title, startDate, description }) => {
      try {
        if (emargement) {
          await validateEmargement(emargement.id);
          show({ message: "L'émargement a été validé", severity: AlertTypes.success });
        } else {
          await addEmargement({
            userName: auth.userName,
            title,
            startDate,
            description,
          });
          show({ message: 'Un emargement a été créé', severity: AlertTypes.success });
        }
        navigate(paths.emargement.path)();
      } catch (error) {
        setError('emargement/submit-error');
      }
    },
    [auth, addEmargement, validateEmargement, emargement, navigate, paths, AlertTypes, show]
  );

  useEffect(() => {
    if (params && params.emargementId) {
      (async () => {
        try {
          const response = await getEmargement({ ...queryParams, id: params.emargementId });
          setEmargement(response.emargements[0]);
        } catch (error) {
        }
      })();
    }
  }, [params, getEmargement, queryParams, AlertTypes, show]);
  const disabled = !!emargement;
  const canValidate = isAgent && disabled && !emargement.isValidated;
  const submitEnabled = !emargement || canValidate;
  const commonFields = {
    title: {
      type: 'text',
      label: 'titre',
      disabled,
    },
    startDate: {
      type: 'date',
      label: 'Date de début',
      disabled,
      minDateField: "startDate",
    },
    description: {
      type: 'text',
      name: 'comment',
      label: 'Description',
      multiline: true,
      rows: 4,
      rowsMax: 15,
      disabled,
    },
  };

  const fields: any = canValidate
    ? {
      ...commonFields,
      isValidated: {
        type: 'checkbox',
        label: 'Je confirme avoir bien pris connaissance du nouveau feuillet de sécurité',
        initialValue: false,
      },
    }
    : commonFields;

  if (params && params.emargementId && !emargement) return null;

  return (
    <div>
      {emargement && (
        <div>
          <Typography color="textPrimary">
            <strong>Numero d'emargement:</strong> {emargement?.id}
          </Typography>
          <Typography color="textPrimary">
            <strong>Statut:</strong> {emargement?.isValidated ? 'Validé' : 'Non-Validé'}
          </Typography>
        </div>
      )}
      <DynamicForm
        error={error}
        initialValue={emargement || { startDate: new Date() }}
        fields={fields}
        onChange={() => { }}
        onSubmit={handleOnSubmit}
      >
        {(form: any) =>
          submitEnabled && (
            <SubmitBtn
              variant="contained"
              color="primary"
              title="Enregistrer et Envoyer"
              disabled={!form.isValid || form.isSubmitting || form.values.isValidated === false}
              isSubmitting={form.isSubmitting}
            />
          )
        }
      </DynamicForm>
    </div>
  );
};

export default EmargementForms;
